export default __webpack_public_path__ + "static/media/about.5b4bdd40.png";